import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { NgForm } from '@angular/forms';
import * as CustomRegistrationFieldModel from '../../../../models/CustomRegistrationField';
import { CustomRegistrationFieldResponse } from "../../../../models/CustomRegistrationFieldResponse";
import { DataService } from "src/app/components/event/data.service";
import Swal from 'sweetalert2';
import { ActivatedRoute } from '@angular/router';
import { Event } from "src/app/models/Event";

@Component({
    selector: 'app-custom-registration-fields',
    templateUrl: './custom-registration-fields.component.html',
    styleUrls: ['./custom-registration-fields.component.scss']
})
export class CustomRegistrationFieldsComponent implements OnInit {

    constructor(private http: HttpClient, 
                private dataservice: DataService, 
                private route: ActivatedRoute){}

    @Input()
    customRegistrationFields: CustomRegistrationFieldModel.CustomRegistrationField[];

    @Input()
    existingResponses: CustomRegistrationFieldResponse[];

    @Input() public readableEventId: string;

    @Input() emailChanged: string;

    @Input() event: Event;

    @ViewChild('customRegistrationFieldsForm', { static: false})

    customRegistrationFieldsForm: NgForm;
    
    @Output() firstNameFromD365 = new EventEmitter<string>();
    @Output() lastNameFromD365 = new EventEmitter<string>();

    private CustomRegistrationFieldTypes = CustomRegistrationFieldModel.Types;
    private selectedGroup;

    private contactId;

    private eventTargetGroups;

    ngOnInit() {
        
        this.processExistingResponses();
        // CHECK EVENT TARGETGROUP //
        if(this.event && this.event.cr9fc_targetgroups){
            this.eventTargetGroups = this.event.cr9fc_targetgroups;
        }
        if(this.route.snapshot.queryParams['cn']) {
            this.contactId = this.route.snapshot.queryParams['cn'];
        }
    }

    ngOnChanges(){
        for(let i=0; i<this.customRegistrationFields.length; i++){
            if(this.customRegistrationFields[i].text=='Ich bin (Teilnahmestatus)'){
                if(this.customRegistrationFields[i].value!=undefined){
                    this.customRegistrationFields[i].value = undefined;
                    this.selectedGroup = undefined;
                    this.dataservice.changeGroup(undefined);
                }
            }
        }    
    }
    /**
     * Checks if the custom registration fields are valid (and all required fields are filled).
     */
    public areRegistrationFieldsValid(): boolean {
        return this.customRegistrationFieldsForm == null || (this.customRegistrationFieldsForm != null && this.customRegistrationFieldsForm.valid);
    }

    /**
     * Resets the custom registration fields.
     */
    public resetForm() {
        this.customRegistrationFieldsForm.reset();
    }

    /**
     * Returns the valid, non-empty responses of the custom registration fields.
     * The value of the responses is represented as string.
     */
    public getCustomRegistrationFieldsResponses(): CustomRegistrationFieldResponse[] {
        let responses: CustomRegistrationFieldResponse[] = [];

        for (let customField of this.customRegistrationFields) {
            let response = customField.createResponse();

            if (response) {
                responses.push(response);
            }
        }

        return responses;
    }
    public valueChange(val){
        this.selectedGroup = val;
        let email = '';
        this.dataservice.currentEmail.subscribe(res => {            
            email = res;
        });
        if(val=='Mitglied' || val == 'Interessentin oder Multiplikatorin'){
            if(email && email.length>0){
                if(val=='Mitglied'){
                    if(this.selectedGroup!=null){                            
                        this.checkingGroup(email, 100000000, 'Mitglied');
                    }
                } else if (val=='Interessentin oder Multiplikatorin'){
                    if(this.eventTargetGroups != 'Mitglieder'){
                        if(this.selectedGroup!=null){
                            this.checkingGroup(email, 150170001, 'Interessentin');
                        }
                    }
                }
            } else if (email.length==0 || email==undefined){
                Swal.fire({
                    icon: 'error',
                    html: `Email Address is Required.`,
                }).then(()=>{
                    for(let i=0; i<this.customRegistrationFields.length; i++){
                        if(this.customRegistrationFields[i].text=='Ich bin (Teilnahmestatus)'){
                            this.customRegistrationFields[i].value = undefined;
                            this.selectedGroup = undefined;
                        }
                    }
                });
            }
        } else {
            this.dataservice.changeGroup(val);
        }
    }

    private processExistingResponses() {
        for (let response of this.existingResponses) {
            let relatedCustomField = this.customRegistrationFields.find(
                customRegistrationField => customRegistrationField.customRegistrationFieldId === response.id
            );

            relatedCustomField.valueAsString = response.value;
        }
    }

    private splitResponses(str: string): string[] {
        return str.split(', ');
    }

    private async checkingGroup(email: string, group: number, groups: string){
        if ( group == 100000000 ){
            const today: Date = new Date();
            const formattedDate: string = today.toISOString().slice(0, 10);  
            const payload = { email: email, formattedDate: formattedDate}          
            await Swal.fire({
                title: 'Bitte warten Sie...',
                timerProgressBar: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading(null);
                    this.dataservice.getUserDetailfromD365(payload).subscribe(async res => {
                        let result = await JSON.parse(JSON.stringify(res));
                        if(result && result.value && result.value.length>0){
                            let firstNameD365: string = (result.value[0]['firstname']).trimEnd();
                            let lastNameD365: string = (result.value[0]['lastname']);                                            
                            this.firstNameFromD365.emit(firstNameD365);
                            this.lastNameFromD365.emit(lastNameD365);
                            this.dataservice.changeGroup(groups);
                            this.selectedGroup = undefined;
                            Swal.close();
                        } else if (result && result.value && result.value.length==0){
                            Swal.fire({
                                icon: 'error',
                                title: 'Contact Not Found',
                                html: `Sie sind mit dieser E-Mail-Adresse <b>${email}</b> nicht als <b>'${groups}'</b> registriert. Bitte verwenden Sie die Adresse, mit der Sie in unserer Datenbank eingetragen sind. Oder melden Sie sich als Gast an, wenn Sie noch kein Mitglied und keine Interessentin sind. <br>Dankeschön!`,
                                footer: '<a href="">Why do I have this issue?</a>'
                            }).then(()=>{
                                for(let i=0; i<this.customRegistrationFields.length; i++){
                                    if(this.customRegistrationFields[i].text=='Ich bin (Teilnahmestatus)'){
                                        this.customRegistrationFields[i].value = undefined;
                                        this.selectedGroup = undefined;
                                    }
                                }
                            });
                        }
                    });
                }
            });
        } else if (group == 150170001){
            const payload = { email: email }
            await Swal.fire({
                title: 'Bitte warten Sie...',
                timerProgressBar: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                showConfirmButton: false,
                didOpen: () => {
                    Swal.showLoading(null);
                    this.dataservice.getPotentialUserDetailFromD365(payload).subscribe(async res => {
                        let result = await JSON.parse(JSON.stringify(res));
                        if(result && result.value && result.value.length>0){                                    
                            let firstNameD365: string = (result.value[0]['firstname']).trimEnd();
                            let lastNameD365: string = (result.value[0]['lastname']);                                            
                            this.firstNameFromD365.emit(firstNameD365);
                            this.lastNameFromD365.emit(lastNameD365);
                            this.dataservice.changeGroup(groups);
                            this.selectedGroup = undefined;
                            Swal.close();
                        } else if (result && result.value && result.value.length==0){
                            Swal.fire({
                                icon: 'error',
                                title: 'Contact Not Found',
                                html: `Sie sind mit dieser E-Mail-Adresse <b>${email}</b><br>nicht als <b>Interessentin oder Multiplikatorin</b> registriert. Bitte verwenden Sie die Adresse, mit der Sie in unserer Datenbank eingetragen sind. Oder melden Sie sich als Gast an, wenn Sie noch kein Mitglied und keine Interessentin sind. <br>Dankeschön!`,
                                footer: '<a href="">Why do I have this issue?</a>'
                            }).then(()=>{
                                for(let i=0; i<this.customRegistrationFields.length; i++){
                                    if(this.customRegistrationFields[i].text=='Ich bin (Teilnahmestatus)'){
                                        this.customRegistrationFields[i].value = undefined;
                                        this.selectedGroup = undefined;
                                    }
                                }
                            });
                        }
                        
                    });
                }
            });
        }
        
        
    }
}
